<template>
  <div class="person-picker">
    <div class="person-picker-button" @click="showSelect">
      <slot></slot>
    </div>
    <a-modal
      :title="title"
      :maskClosable="false"
      :closable="false"
      :width="600"
      @ok="confirmSelect"
      v-model="visible">
      <div class="flex-box person-modal-area">
        <div class="flex-grow flex-box vertical">
          <div class="person-modal-title">
            <a-input-search v-model="keyword" placeholder="输入姓名搜索" @search="onSearch" />
          </div>
          <div class="person-modal-content all-person-list" @scroll="handleScroll">
            <div class="modal-person-list" v-if="list && list.length > 0">
              <person-item
                :class="{
                  'select-disable': disableList.findIndex(p => p[uniqueKey] == item[uniqueKey]) >= 0,
                  'person-selected': selectList.findIndex(p => p[uniqueKey] == item[uniqueKey]) >= 0
                }"
                :person="item"
                :show-tel="showTel"
                @select="selectPerson(item)"
                v-for="item in list"
                :key="item.id">
                <a-icon type="check" class="person-operate"/>
              </person-item>
            </div>
            <a-empty :image="simpleImage" description="搜索不到结果" v-else/>
            <div class="person-loading" v-show="loading">
              <a-icon type="loading"/>
            </div>
          </div>
        </div>
        <div class="flex-grow flex-box vertical">
          <div class="person-modal-title">
            <div class="person-modal-text">已选择的成员</div>
          </div>
          <div class="person-modal-content selected-list">
            <div class="modal-person-list">
              <person-item
                :person="item"
                :show-tel="showTel"
                v-for="(item, i) in selectList"
                :key="item.id">
                <a-icon type="close" class="person-operate" @click="removePerson(i)"/>
              </person-item>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
    import { Empty } from 'ant-design-vue';
    import {clone} from "../../common/js/tool";
    import personItem from "../person-item";

    export default {
        name: "person-picker",
        props: {
            title: String,
            value: Array,
            multiple: Boolean,
            selectDisable: Boolean,
            showTel: Boolean,
            url: {
                type: String,
                required: true
            },
            query: [String, Function],
            nameKey: {
                type: String,
                default: 'name'
            },
            telKey: {
                type: String,
                default: 'tel'
            },
            uniqueKey: {
                type: String,
                default: 'id'
            }
        },
        components: {
            personItem,
        },
        data() {
            return {
                keyword: '',
                visible: false,
                list: null,
                disableList: [],
                selectList: [],
                page: 1,
                loading: false,
                more: true,
                simpleImage: Empty.PRESENTED_IMAGE_SIMPLE
            }
        },
        methods: {
            setSelectList() {
                const value = this.value;
                const list = value ? clone(value) : [];
                if(this.selectDisable) {
                    this.disableList = list;
                } else {
                    this.selectList = list;
                }
            },
            selectPerson(item) {
                if(this.disableList.findIndex(p => p.id == item.id) === -1) {
                    if(this.multiple) {
                        const index = this.selectList.findIndex(p => p.id == item.id);
                        if(index >= 0) {
                            this.selectList.splice(index, 1);
                        } else {
                            this.selectList.push(item);
                        }
                    } else {
                        this.selectList = [item];
                    }
                }
            },
            removePerson(i) {
                this.selectList.splice(i, 1);
            },
            confirmSelect() {
                const selectList = this.selectList;
                this.$emit("change", selectList);
                this.selectList = [];
                this.visible = false;
            },
            showSelect() {
                this.keyword = "";
                this.refreshList();
                this.setSelectList();
                this.visible = true;
            },
            onSearch() {
                this.refreshList();
            },
            handleScroll(e) {
                const dom = e.currentTarget;
                if (dom.scrollTop + dom.offsetHeight >= dom.scrollHeight - 36) {
                    this.getPersonList();
                }
            },
            refreshList() {
                this.page = 1;
                this.more = true;
                this.list = [];
                this.getPersonList();
            },
            getPersonList() {
                const loading = this.loading;
                const more = this.more;
                if(loading || !more) return;
                this.loading = true;
                const nameKey = this.nameKey;
                const telKey = this.telKey;
                const page = this.page;
                let url = `${this.url}?page=${page}&pageSize=20`;
                if(typeof this.query === 'function') {
                    url += this.query(this.keyword);
                } else {
                    if(this.query) {
                        url += this.query;
                    }
                    if(this.keyword) {
                        url += `&filter[or][0][${nameKey}][like]=${this.keyword}&filter[or][1][${telKey}][like]=${this.keyword}`;
                    }
                }
                this.$axios(url).then(res => {
                    const list = res.data;
                    if(page == 1) {
                        this.list = list;
                    } else {
                        this.list = this.list.concat(list);
                    }
                    if(page >= res.page.pageCount) {
                        this.more = false;
                    } else {
                        this.page += 1;
                    }
                }).finally(() => this.loading = false);
            }
        }
    }
</script>

<style lang="less">
  .modal-person-list {
    padding: 10px 0;
    .person-item {
      cursor: pointer;
      &:not(.select-disable):hover {
        background-color: @background-color-base;
      }
      &.select-disable {
        cursor: not-allowed;
      }
    }
    .person-name {
      flex: 1;
    }
  }
  .selected-list {
    .person-item .person-operate {
      display: block;
    }
  }
  .select-person-btn {
    cursor: pointer;
    color: @primary-color;
  }
  .person-modal-area {
    height: 480px;
  }
  .person-modal-title {
    padding: 0 12px 12px;
    font-size: 0;
  }
  .person-modal-text {
    line-height: 32px;
    color: @text-color-secondary;
    font-size: 14px;
  }
  .person-modal-content {
    flex: 1;
    border: var(--border);
    overflow-y: auto;
    &.selected-list {
      border-left: none;
    }
  }
  .person-loading {
    text-align: center;
    color: @primary-color;
  }
</style>
